export const BREAST_PUMP_BANNER_NAME = 'breast-pump'
export const SHOW_HEALTH_REGISTRY_BANNERS_KILL_SWITCH =
  'dme_kill_switch_show_health_registry_banners'
